import React from "react";
import { useTranslation } from "react-i18next";
import DataLakePageNavigation from "data-lake/components/DataLakePageNavigation";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import { Row, Col } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import usePermissions from "hooks/usePermissions";
import useDataLakeBackends from "data-lake/data-lake-backend-config/hooks/useDataLakeBackends";
import useDataLakeConfig from "data-lake/configurations/hooks/useDataLakeConfig";
import DataLakeConfigForm from "data-lake/configurations/DataLakeConfigForm";
const DataLakeConfigPage = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const { isPermitted } = usePermissions();
  const canReadBackendConfig = isPermitted("data_lake_backend_config:read");
  const { data: backendsList, isInitialLoading: isLoadingBackends } = useDataLakeBackends({
    enabled: canReadBackendConfig
  });
  const { data: config, isInitialLoading: isLoadingCurrentConfig } = useDataLakeConfig();
  if (isLoadingBackends || isLoadingCurrentConfig) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("config_page.title") }, /* @__PURE__ */ React.createElement(DataLakePageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("config_page.title"),
      documentationLink: {
        title: t("config_page.documentation_link"),
        path: DocsHelper.PAGES.DATA_LAKE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("config_page.description"))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeConfigForm, { backends: backendsList, config, showActiveBackend: canReadBackendConfig }))));
};
export default DataLakeConfigPage;
